// fr_pms_revenue.ts
// Tłumaczenia dla PMS.Revenue.tsx

export const frPmsRevenue = {

  title: "Revenue Management",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    forecast:          "Previsions et insights",
    demandCalendar:    "Calendrier de la demande",
    activeRestrictions:"Restrictions actives",
    eventsImpact:      "Impact des evenements",
    conflictEngine:    "Moteur de conflits",
    governance:        "Gouvernance",
    derivedRules:      "Regles derivees",
    groupsBlocks:      "Groupes et blocages",
  },

  // ── Etykiety KPI / tabeli ─────────────────────────────────────────────────
  labels: {
    adrGap:           "Ecart ADR",
    cancellationRate: "Taux d'annulation",
    corporatePickup:  "Pickup corporate",
    behindPace:       "En retard",
    onPace:           "Dans le rythme",
    base:             "Base",
    active:           "Active",
    corporate:        "Corporate",
    event:            "Evenement",
    forecast:         "Prognoza",
    critical:         "Critique",
  },

} as const;

export default frPmsRevenue;
